/**
 * Resumen de los tickets de una persona para su dashboard (usuarios sin
 * permiso de soporte). Lógica pura.
 */

/**
 * @param {Array<Object>} tickets - Tickets de la persona (completed, responsibleId, dueAt).
 * @param {number} [now=Date.now()]
 * @returns {{total: number, open: number, resolved: number, unassigned: number, overdue: number}}
 */
export const summarizeMyTickets = (tickets = [], now = Date.now()) => {
  const summary = { total: 0, open: 0, resolved: 0, unassigned: 0, overdue: 0 }
  for (const t of tickets) {
    summary.total++
    if (t.completed) {
      summary.resolved++
      continue
    }
    summary.open++
    if (!t.responsibleId) summary.unassigned++
    if (t.dueAt && new Date(t.dueAt).getTime() < now) summary.overdue++
  }
  return summary
}

/**
 * Saludo según la hora local.
 * @param {Date} [date=new Date()]
 * @returns {string}
 */
export const greeting = (date = new Date()) => {
  const h = date.getHours()
  if (h < 12) return 'Buenos días'
  if (h < 19) return 'Buenas tardes'
  return 'Buenas noches'
}
